import Router from "@olton/router";

globalThis.Router = Router;
